// *****vue-i8n*****
// import Vue from 'vue'
// import VueI18n from 'vue-i18n'
// import messages from './langs'

// Vue.use(VueI18n)
// //从localStorage中拿到用户的语言选择，如果没有，那默认中文。
// const i18n = new VueI18n({
//   locale: localStorage.lang || 'cn',
//   messages,
// })
// export default i18n


// *****兼容element-ui*****
import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';
import messages from './langs';
Vue.use(VueI18n);
function getCurrentLocaleFromUrl() {
  const path = window.location.hostname;
  const segments = path.substring(path.length-14,path.length);
  if (segments==='feixing001.com') {
    return 'cn';
  }else{
    return 'en';
  }
}
console.log(getCurrentLocaleFromUrl())
//从localStorage中拿到用户的语言选择，如果没有，那默认中文。
const i18n = new VueI18n({
  locale: getCurrentLocaleFromUrl(),
  messages,
})
locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js